import { HttpErrorResponse } from '@angular/common/http';
import {
    GetNotesTypesNamesAndIdsDTO,
    INotesTypeEntityDTO,
    UpdateNotesTypeDto,
} from '@modeso/types__aumico-lib-notes-be';
import { Action, createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

export const getNotesTypes = createAction('[Aumico-Notes-NotesTypes] getNotesTypes');

export const onGetNotesTypesSuccessfully = createAction(
    '[Aumico-Notes-NotesTypes] onGetNotesTypesSuccessfully',
    props<{ payload: INotesTypeEntityDTO[] }>(),
);

export const onGetNotesTypesFailed = createAction(
    '[Aumico-Notes-NotesTypes] onGetNotesTypesFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const createNotesType = createAction(
    '[Aumico-Notes-NotesTypes] createNotesType',
    props<{ payload: INotesTypeEntityDTO }>(),
);

export const onCreateNotesTypeSuccessfully = createAction(
    '[Aumico-Notes-NotesTypes] onCreateNotesTypeSuccessfully',
    props<{ payload: INotesTypeEntityDTO }>(),
);

export const onCreateNotesTypeFailed = createAction(
    '[Aumico-Notes-NotesTypes] onCreateNotesTypeFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateNotesType = createAction(
    '[Aumico-Notes-NotesTypes] updateNotesType',
    props<{ payload: UpdateNotesTypeDto }>(),
);

export const onUpdateNotesTypeSuccessfully = createAction(
    '[Aumico-Notes-NotesTypes] onUpdateNotesTypeSuccessfully',
    props<{ payload: UpdateNotesTypeDto }>(),
);

export const onUpdateNotesTypeFailed = createAction(
    '[Aumico-Notes-NotesTypes] onUpdateNotesTypeFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const onSelectNotesType = createAction(
    '[Aumico-Notes-NotesTypes] onSelectNotesType',
    props<{ payload: string }>(),
);

export const getAllNotesTypesNamesAndIds = createActionGroup({
    source: '[Aumico-Notes-NotesTypes] Get All Notes Types Names And Ids',
    events: {
        'Get All Notes Types Names And Ids': emptyProps(),
        'Get All Notes Types Names And Ids Success': props<{ payload: GetNotesTypesNamesAndIdsDTO[] }>(),
        'Get All Notes Types Names And Ids Failed': props<{ payload: HttpErrorResponse }>(),
    },
});

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
